import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import React from 'react';
import { MasterViewPage } from './MasterPage';


export const AuthSuccess = () => {
    return <MasterViewPage>
        <Container sx={{ textAlign: 'center' }}>
            <Typography component='h1'>Connexion réussie</Typography>
            <Typography>Redirection en cours...</Typography>
        </Container>
    </MasterViewPage>;
};
